import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import searchIcon from "../../../assets/images/dashboard-search.svg";
import uploadIcon from "../../../assets/images/uploadd.png";
import filterIcon from "../../../assets/images/filter.svg";
import { Select, MenuItem, Tooltip } from "@mui/material";
import appliedFiltersIcon from "../../../assets/images/filterApplied.svg";
import { getItemInLocalStorage } from "../../../services/localStorage";
import { hasPermission } from "../../../utils/roleBasedAccess";
import DownloadReport from "../../../components/DownloadReportPopup";
import { DOWNLOAD_OPTIONS } from "../../../constants";
import {UN_BLESSED_FILTER_ID} from "../../../constants/textConstants";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

interface DashboardHeaderProps {
  title?: string;
  onSearch: (value: string) => void; 
  setSearchPopup?: (value: boolean) => void;
  onClick?: () => void;
  errors?: number;
  totalDataLength?: number;
  appliedFilters?: any;
  dashboardClassname?: string;
  enableFilter?: boolean;
  enableExport?: boolean; 
  onExport?: () => void;
  searchValue: {
    value: string;
    open: boolean;
  };
  filterPills?: React.ReactNode;
  setSearchValue?: (value: { value: string; open: boolean }) => void;
  onFilterClick?: () => void;
  onSearchValueChange: (val: string) => void;
  activeTab?: number;
  onEmailClick?: () => void;
  setSelectedOption?: (option: "filtered" | "all") => void;
  selectedOptions?: "filtered" | "all" | "download";
  handleDownload?: (reportName: string, selectedReport?: string) => void;
  isDraftsPage?: boolean;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  onSearch,
  setSearchPopup, 
  title,
  enableFilter,
  enableExport,
  onExport,
  appliedFilters,
  filterPills,
  onClick,
  onFilterClick,
  errors,
  totalDataLength,
  dashboardClassname,
  searchValue,
  setSearchValue,
  onSearchValueChange,
  activeTab = 0,
  onEmailClick,
  setSelectedOption,
  selectedOptions,
  handleDownload,
  isDraftsPage
}) => {
  const [debouncedValue, setDebouncedValue] = useState("");
  const [showDownloadReport, setShowDownloadReport] = useState(false);
  const selectedKpiTab = useSelector(
    (state: RootState) => state.ProgramReducer.selectedKpiTab,
  );
const [selectedMainFilter,setSelectedMainFilter]=useState("")
  const searchInput = (value: string) => {
    onSearchValueChange(value);
  };
  const userRole = getItemInLocalStorage("seekerDetails")?.role || "";
  const hasSeatPermission = hasPermission(userRole, "seat-allocations-tab", "R");
  const hasAppliedFilters =
    appliedFilters && Object.keys(appliedFilters).length > 0;

  useEffect(() => {
    if (searchValue.value && searchValue.value.trim() !== "") {
      onSearch(searchValue.value.trim());
    } 
    // else {
    //   onSearch(""); 
    // }
  }, [activeTab]);

  return (
    <div
      className={`${styles.dashboardHeader} ${dashboardClassname || ""}`}
      data-testid="dashboard-header"
    >
      <div className={styles.heading}>
        {/* {`${title} list`|| `${selectedKpiTab?.label} list` } */}
        {filterPills}
        {/* Show total records found always */}
        {totalDataLength !== undefined && (
          <span className={styles.totalRecords}>
        {totalDataLength} Seekers found
          </span>
        )}
        {errors !== undefined &&
          totalDataLength !== undefined &&
          errors > 0 &&
          errors < totalDataLength && (
            <div className={styles.errorMsg}>
              &nbsp;&nbsp;({errors} invalid rows found in the file. only valid
              rows will be uploaded)
            </div>
          )}
        {errors !== undefined &&
          totalDataLength !== undefined &&
          errors > 0 &&
          errors === totalDataLength && (
            <div className={styles.errorMsg}>
              &nbsp;&nbsp;(All rows are invalid, can&apos;t upload the file)
            </div>
          )}

        {/* Always show download report text if export is enabled */}
        {/* {enableExport && (
          <span
            className={styles.downloadReportText}
            style={{ cursor: "pointer" }}
            onClick={() => 
              // setShowTypeOfDownload && setShowTypeOfDownload(true)
              setShowDownloadReport(true)
            }
          >
            &nbsp;&nbsp;download report
          </span>
        )} */}
        
       
          
      </div>

      <div className={styles.iconsBlock} data-testid="icons-block">
         {
          enableExport && !isDraftsPage && (
            <Select
              // value={selectedOptions || "download report"}
              onChange={(e) => {
                setSelectedOption && setSelectedOption(e.target.value as "filtered" | "all");
              }}
              displayEmpty
              className={styles.select}
              variant="standard"
              disableUnderline
              disabled={!totalDataLength || totalDataLength <= 0}
              sx={{
                "& .MuiInput-underline:before, & .MuiInput-underline:after": {
                  borderBottom: "none !important",
                },
                "& .MuiSelect-root": {
                  width: "154px !important",
                },
                "& .MuiInputBase-root": {
                  border: "none !important",
                  boxShadow: "none !important",
                },
                "& .MuiSelect-select": {
                  color: "#1976d2",
                },
                background: "transparent",
              }}
              inputProps={{ "aria-label": "Select Category" }}
              renderValue={(selected) =>
                "download report"
              }
            >
              {DOWNLOAD_OPTIONS.options.map((option) => (
                <MenuItem key={option.value} value={option.value}
                  onClick={()=> {
                    setShowDownloadReport(true)
                    setSelectedMainFilter(option.value)
                  }}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          )
        }
        {enableExport && isDraftsPage && (
          <span
            className={styles.downloadReportText}
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleDownload && handleDownload("Drafts Report", "all");
            }}
          >
            download report
          </span>
        )}
        {searchValue.open && (
          <div className={styles.search} data-testid="search-container">
            <input
              type="text"
              className={styles.searchInput}
              autoFocus
              value={searchValue.value}
              placeholder="Search seeker with name or mobile number"
              onChange={(e) => {
                onSearchValueChange(e.target.value);
                if (e.target.value === "") {
                  onSearch(""); // Show all results when input is cleared
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch(searchValue.value.trim());
                  if (searchValue.value.trim() === "") {
                    setTimeout(() => {
                      setSearchValue &&
                        setSearchValue({ value: "", open: false });
                    }, 500); // closes after 0.5 seconds, adjust as needed
                  }
                }
              }}
              data-testid="search-input"
            />
          </div>
        )}
        <Tooltip title="Search" arrow>
          <button className={styles.filter} data-testid="search-button">
            <img
              src={searchIcon}
              alt="search"
              data-testid="search-icon"
              onClick={() =>
                setSearchValue &&
                setSearchValue({
                  value: searchValue.value,
                  open: !searchValue.open,
                })
              }
            />
          </button>
        </Tooltip>
        {errors !== undefined &&
          totalDataLength !== undefined &&
          errors < totalDataLength && (
            <Tooltip title="upload" arrow>
              <button className={styles.filter} data-testid="search-button">
                <img
                  src={uploadIcon}
                  alt="upload"
                  className={styles.uploadIcon}
                  data-testid="search-icon"
                  onClick={() => onClick && onClick()}
                />
              </button>
            </Tooltip>
          )}
       
        {enableFilter && (
          <Tooltip title="Filter" arrow>
            <button className={styles.filter} onClick={onFilterClick}>
              <img
                src={hasAppliedFilters ? appliedFiltersIcon : filterIcon}
                alt="filter icon"
                data-testid="filter-icon"
              />
            </button>
          </Tooltip>
        )}
        {/* {enableExport && (
          <Tooltip title="Export" arrow>
            <button
              className={styles.filter}
              data-testid="export-button"
              onClick={onExport}
            >
              <img
                src={exportIcon}
                alt="export"
                className={styles.exportIcon}
                data-testid="export-icon"
              />
            </button>
          </Tooltip>
        )} */}
        {/* {hasPermission(userRole, "email-icon", "R") && !UN_BLESSED_FILTER_ID.includes(activeTab) && (
          <Tooltip title="Email" arrow>
            <button
              className={styles.filter}
              data-testid="export-button"
              onClick={onEmailClick}
            >
              <img
                src={emailIcon}
                alt="email"
                className={styles.emailIcon}
                data-testid="email-icon"
              />
            </button>
          </Tooltip>
        )} */}
      </div>
      {showDownloadReport && (
        <DownloadReport
          open={showDownloadReport}
          onClose={() => setShowDownloadReport(false)}
          valueSelected={selectedMainFilter}
          onContinue={(reportName: string, selectedReport?: string) => 
            {
              handleDownload && handleDownload(reportName, selectedReport)
              setShowDownloadReport(false)}}
          totalRecords={totalDataLength}
        />
      )}
    </div>
  );
};

export default DashboardHeader;
